import type { Project } from "@easyshot/shared";
/** Only actual finished videos can represent the generated result. */
export function projectCoverVideo(project: Pick<Project, "jobs">): string | undefined {
  return project.jobs.find(job => job.status === "succeeded" && job.videoUrl)?.videoUrl;
}

/** Actual output duration only; never substitute the requested script length. */
export function formatVideoDuration(seconds: number | undefined): string | undefined {
  if (seconds === undefined || !Number.isFinite(seconds) || seconds <= 0) return undefined;
  const total = Math.ceil(seconds);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor(total / 60) % 60;
  const remaining = total % 60;
  return [ ...(hours ? [hours] : []), minutes, remaining ].map(n => String(n).padStart(2, "0")).join(":");
}
